<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 mat-dialog-title>Modificar persona</h1>
<div class="spinner-container">
  <app-form-only-persona-update></app-form-only-persona-update>
</div>
